import React, {Fragment} from 'react';
import '../App.css'
import { BrowserRouter as Router, Routes ,Route } from 'react-router-dom';
import Header from "../services/headers and footers/Header";
import Contact from "./contact/Contact";
import LoginComp from "./login/Login";
import DashboardComp from "./admin/Dashboard";
import Footer from "../services/headers and footers/Footer";
import Submissions from "./admin/Submits";
import FolderBrowser from "../services/downloads/URLCreate";
import NewHomePage from "../New_Homepage";
import DynamicPage from "./DynamicPage";
import MaintenancePage from "./MaintenancePage";
import { AuthProvider } from "../auth/AuthContext";
import AdminRoute from "../auth/AdminRoute";
import AdminLayout from "../auth/AdminLayout";
import PageEditor from "./admin/pages/PageEditor";
import PagesAdmin from "./admin/pages/PagesAdmin";


function MainPage() {

    return (
        <div className={'App'}>
            <div>
                <Fragment>
                    <Router basename={'/'}>
                        <AuthProvider>
                            <div><Header/></div>
                            <Routes>
                                <Route path={"/"} exact element={<NewHomePage />}/>
                                <Route path="*" element={<DynamicPage />} />
                                <Route path={"/data/*"} element={<FolderBrowser/>}/>
                                <Route path={"/files/*"} element={<FolderBrowser />} />
                                <Route path={"/contact"} element={<Contact/>}/>
                                <Route path={"login"} element={<LoginComp/>}/>
                                <Route
                                    path="/admin/*"
                                    element={
                                        <AdminRoute>
                                            <AdminLayout />
                                        </AdminRoute>
                                    }
                                >
                                    <Route index element={<DashboardComp />} />
                                    <Route path={"contact-messages"} element={<Submissions/>}/>
                                    <Route path={"pages"} element={<PagesAdmin />} />
                                    <Route path="pages/:id" element={<PageEditor />} />
                                </Route>
                            </Routes>
                        </AuthProvider>
                    </Router>
                </Fragment>
            </div>
            <div><Footer/></div>
        </div>
    );
}

export default MainPage;
